import { SiteUrls } from '@tableau/shared-urls';

import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { HelpService } from '../../ts/services/HelpService';
import { WelcomeScreenStateProps } from '../components/WelcomeScreen';
import { WelcomeScreenLinks } from './WelcomeScreenLinks';

export class WelcomeScreenPropsByRole {
  private links: WelcomeScreenLinks;

  constructor(siteUrls: SiteUrls, helpService: HelpService) {
    this.links = new WelcomeScreenLinks(siteUrls, helpService);
  }

  getProps(role: string): WelcomeScreenStateProps {
    switch (role) {

      case SiteRoles.ServerAdministrator:
      case SiteRoles.SiteAdministratorCreator:
      case SiteRoles.SupportUser:
        return {
          header: Messages.home_welcomeScreen_HeaderAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderAdmin(),
          primaryButtonLink: this.links.createWorkbook(),
          bottomLinks: [
            this.links.manageProjects(),
            this.links.manageUsers(),
            this.links.downloadDesktop(),
            this.links.downloadPrep(),
          ],
        };

      case SiteRoles.SiteAdministratorExplorer:
        return {
          header: Messages.home_welcomeScreen_HeaderAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderAdmin(),
          primaryButtonLink: this.links.manageProjects(),
          bottomLinks: [
            this.links.manageUsers(),
            this.links.createWorkbook(),
          ],
        };

      case SiteRoles.Creator:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.createWorkbook(),
          bottomLinks: [
            this.links.downloadDesktop(),
            this.links.downloadPrep(),
          ],
        };

      case SiteRoles.Explorer:
      case SiteRoles.ExplorerCanPublish:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };

      case SiteRoles.Viewer:
      case SiteRoles.Guest:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };

      default:
        return {
          header: Messages.home_welcomeScreen_HeaderNonAdmin(),
          subHeader: Messages.home_welcomeScreen_SubheaderNonAdmin(),
          primaryButtonLink: this.links.startExploring(),
          bottomLinks: [],
        };
    }
  }
}
